<template>
  <div v-show="isCheckinWarning && bookingAreasSplit.isBooking">
    <div class="alert-contract" role="alert">
      <div class="close-box">
        <v-btn class="close" icon @click="isCheckinWarning = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <div class="media" @click="dialogCheckinWarning = true">
        <div class="media-left">
          <v-btn text class="btn-renew-contract">
            <img width="60px" class="media-object" src="../assets/images/alarm-icon.png" alt="megaphone-icon" />
          </v-btn>
        </div>
        <div class="media-body">
          <h4 class="media-heading" style="line-height: unset;">
            <v-btn color="info" text class="btn-renew-contract">
              <b>{{ $t('area.have_renter_in_this_day') }}</b>
            </v-btn>
          </h4>
          <span v-if="bookingAreasSplit.daily" class="mr-2">
            {{ $t('daily') }}
            <b>{{ bookingAreasSplit.daily }}</b> {{ $t('area.space') }}
          </span>
          <span v-if="bookingAreasSplit.monthly">
            {{ $t('monthly') }}
            <b>{{ bookingAreasSplit.monthly }}</b> {{ $t('area.space') }}
          </span>
        </div>
      </div>
    </div>
    <template>
      <v-dialog v-model="dialogCheckinWarning" max-width="600" persistent scrollable>
        <v-card flat outlined :loading="isLoading" min-height="30">
          <v-card-title class="d-flex justify-space-between align-center">
            <div class="d-flex justify-space-between" style="width: 100%">
              <span>{{ $t('area.have_renter_in_this_day_title') }}</span>
              <v-btn
                color="black"
                icon
                @click="dialogCheckinWarning = false; isAll = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="padding:0;" v-if="bookingAreas && bookingAreas.length">
            <div v-for="bookingArea of bookingAreas" :key="bookingArea.objectId" class="booking-box"
              @click="bookingClick(bookingArea)">
              <div class="mr-5">
                <img width="60px" v-if="bookingArea.type == 'daily'" src="../assets/images/day-icon.png" alt="day-icon" />
                <img width="60px" v-if="bookingArea.type == 'monthly'" src="../assets/images/month-icon.png"
                  alt="month-icon" />
              </div>
              <div>
                <div style="font-size:17px;">
                  <b>{{ fullName(bookingArea.booking.customer) }}</b>
                </div>
                <div>
                  <b>{{ $t('area.space') }} {{ bookingArea.area.name }}</b>
                </div>
                <div>
                  {{ $t('area.enter_stall_date') }}
                  <b>{{ dateFormat(bookingArea) }}</b>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-card-text v-else>
            <div class="block m-10 text-center text-gray-400" style="font-size:22px;">{{ $t('area.no_renter_in_this_day') }}</div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <BookingDialog
        v-if="currentBooking"
        v-model="bookingDialog"
        :marketId="marketId"
        :projectId="projectId"
        :booking="currentBooking"
        @createBookingSuccess="createBookingSuccess"
        @setBooking="setBooking"
        :isMainLoading="isLoading"
      />
    </template>
  </div>
</template>

<script>
import BookingDialog from "./BookingDialog.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    BookingDialog
  },
  created() {
    this.initData();
  },
  props: {
    areas: {
      type: Array
    }
  },
  watch: {
    areas: {
      handler(value) {
        this.initData();
      },
      deep: true
    },
    bookingAreas(value) {
      this.bookingAreasSplit.daily = value.filter(
        ba => ba.type == "daily"
      ).length;
      this.bookingAreasSplit.monthly = value.filter(
        ba => ba.type == "monthly"
      ).length;
      this.bookingAreasSplit.isBooking =
        this.bookingAreasSplit.monthly > 0 || this.bookingAreasSplit.daily > 0;
      // if(!this.bookingAreasSplit.isBooking) this.dialogCheckinWarning = false;
    }
  },
  data() {
    return {
      marketId: this.$route.params.marketId,
      projectId: this.$route.params.projectId,
      bookingAreas: null,
      bookingAreasSplit: { daily: 0, monthly: 0, isBooking: false },
      isLoading: false,
      isCheckinWarning: true,
      dialogCheckinWarning: false,
      bookingDialog: false,
      currentBooking: null
    };
  },

  methods: {
    async initData() {
      this.isLoading = true;
      await this.getBookingCheckinToday();
      this.isLoading = false;
    },
    async getBookingCheckinToday() {
      try {
        this.bookingAreas = await this.$store.dispatch(
          "booking/getBookingCheckinToday",
          {
            marketId: this.marketId
          }
        );
        for (let bookingArea of this.bookingAreas) {
          if (bookingArea.booking && bookingArea.booking.areaBookings) {
            let idx = bookingArea.booking.areaBookings.findIndex(
              i => i.objectId == bookingArea.objectId
            );
            if (idx >= 0) {
              bookingArea.booking.areaBookings[idx] = bookingArea;
            }
          }
        }
      } catch (e) {
        this.$toast.show({
          content: this.$t('contract.error_get_contract'),
          color: "error"
        });
      }
    },
    bookingClick(bookingArea) {
      if (bookingArea && !this.isLoading) {
        this.currentBooking = bookingArea.booking;
        this.bookingDialog = true;
      }
    },
    setBooking(booking) {
      this.currentBooking = booking;
    },
    async createBookingSuccess(booking) {
      if (booking) {
        this.currentBooking = booking;
      }
      if (this.currentBooking && this.currentBooking.objectId) {
        this.isLoading = true;
        this.currentBooking = await this.$store.dispatch(
          "booking/getBooking",
          this.currentBooking.objectId
        );
        this.isLoading = false;
      }
      this.$emit("reloadContract", this.currentBooking);
      this.initData();
    },
    fullName(data) {
      let res = "-";
      if (data && data.type == "company") {
        res = `${data.companyName}`;
      } else if (data && data.type == "personal") {
        res = `${data.title} ${data.firstName} ${data.lastName}`;
      }
      return res;
    },
    dateFormat(bookingArea) {
      let format =
        bookingArea.type == "daily" ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY";
      let resStart = "";
      let resEnd = "";
      let startDate = bookingArea.startDate;
      let endDate = bookingArea.endDate;
      if (startDate && startDate.iso) {
        resStart = this.$moment(startDate.iso).format(format);
      }
      if (endDate && endDate.iso) {
        resEnd = this.$moment(endDate.iso).format(format);
      }
      return `${resStart} - ${resEnd}`;
    }
  }
};
</script>

<style scoped>
.alert-contract {
  position: relative;
  margin-bottom: 10px;
  background: #fffc97;
  animation: zoomIn 0.4s;
  -webkit-animation: zoomIn 0.4s;
  border-color: #fffc97;
  border: 1px solid transparent;
  border-radius: 4px;
  transition: transform 0.3s ease;
}

.alert-contract:hover {
  transform: scale(1.01);
}

.media {
  margin-top: 0;
  padding: 15px;
  overflow: hidden;
  zoom: 1;
  cursor: pointer;
}

.media-body,
.media-left {
  display: table-cell;
  vertical-align: top;
}

.media-left {
  padding-right: 10px;
}

.media-object {
  display: block;
}

.media-heading {
  margin-top: 0;
  margin-bottom: 5px;
  line-height: unset;
}

.btn-renew-contract {
  height: unset !important;
  padding: 0 !important;
  font-size: 18px;
  letter-spacing: 0;
}

.close-box {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  top: 0;
  right: 0;
  align-items: flex-end;
  height: 100%;
  padding: 5px 10px;
}

.close {
  font-size: 21px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.2);
  background: #fff;
}

.booking-box {
  padding: 20px 15px;
  margin: 20px 15px;
  border: 1px solid #80808055;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.booking-box:hover {
  background: #80808011;
}

.v-data-table::v-deep th {
  color: #000;
  font-size: 1rem !important;
  text-align: center !important;
}

.v-data-table::v-deep td {
  font-size: 1rem !important;
  text-align: center !important;
  padding-right: 2rem !important;
}

@keyframes zoomIn {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}
</style>